import React from 'react'
import PropTypes from 'prop-types'
import StaticOverviewTableItem from "./StaticOverviewTableItem"

StaticOverviewTableBody.propTypes = {
    statics: PropTypes.array,
    error: PropTypes.string
}

function StaticOverviewTableBody(props) {
    const {statics, error} = props

    return (
        <tbody className='StaticOverviewTableBody'>
        {
            !!statics && statics.length > 0 && statics.map((item, index) => (
                <StaticOverviewTableItem key={index} item={item}/>
            ))
        }
        {
            !!error && error.length > 0 && <tr>
                <td className="text-danger" colSpan={9}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default StaticOverviewTableBody
